import React from 'react';
import { motion } from 'framer-motion';

const InvoiceStatusFilter = ({ activeFilter, onFilterChange }) => {
  const filters = [
    { id: 'all', label: 'All Invoices' },
    { id: 'active', label: 'Active' },
    { id: 'canceled', label: 'Archived' }
  ];

  return (
    <div className="flex justify-center mb-4 border border-grayteck-200 dark:border-grayteck-700 rounded-lg divide-x divide-grayteck-200 dark:divide-grayteck-700 overflow-hidden">
      {filters.map(filter => (
        <motion.button
          key={filter.id}
          whileHover={{ backgroundColor: 'rgba(0,0,0,0.05)' }}
          whileTap={{ scale: 0.98 }}
          onClick={() => onFilterChange(filter.id)}
          className={`py-2 px-4 flex-1 text-sm font-medium transition-colors ${
            activeFilter === filter.id 
              ? 'bg-grayteck-100 dark:bg-darkbg-700 text-grayteck-900 dark:text-grayteck-100' 
              : 'bg-white dark:bg-darkbg-800 text-grayteck-600 dark:text-grayteck-400 hover:bg-grayteck-50 dark:hover:bg-darkbg-700'
          }`}
        >
          {filter.label}
        </motion.button>
      ))}
    </div>
  );
};

export default InvoiceStatusFilter;